<template>
  <section id="admin-filter">
    <h4>Data Option Type filter</h4>
    <div class="form-group">
      <label for="dot-filter-code" class="form-label">Code</label>
      <input type="text" class="form-control" id="dot-filter-code" v-model="code"/>
    </div>
    <div class="form-group">
      <label for="dot-filter-name" class="form-label">Name</label>
      <input type="text" class="form-control" id="dot-filter-name" v-model="name"/>
    </div>
    <div class="form-group">
      <label for="dot-filter-desc" class="form-label">Description</label>
      <input type="text" class="form-control" id="dot-filter-desc" v-model="description"/>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  export default {
    name: 'DataOptionTypeFilter',
    mixins: [ FilterMixin ],
    data () {
      return {
        code: '',
        name: '',
        description: ''
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/DataOptionType/DataOptionTypeFilter.vue